module.exports = __webpack_public_path__ + "img/new13.3437faeb.jpg";